//import axios from "@/app/Axios";
import axios from '@/http/connection/axios';
//import routerProtected from "@/app/routerProtected";
class Roles {
    async rolesget() {
        try {
            const response = await axios.get("/getroles");
            if (response && response.data) {
                return { status: true, records: response.data };
            } else {
                console.error("Respuesta inválida o sin registros.");
                return { status: false, records: [] };
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return { status: false, message: error.response.data.message };
            } else {
                console.log(error);
                return { status: false, message: "Error interno del servidor" };
            }
        }
    }
    async registrarrole(roles) {
        try {
            const response = await axios.post("/postroles", roles);
            console.log("Respuesta de Servicio roles",response);
            return response.data;
        } catch (error) {
            console.log(error);
            return { status: false, message: "Error interno del servidor" };
        }
    }
    async modificarroles(roles) {
        try {
          const response = await axios.put(
            `/putroles/${roles.id}`,
            roles
          );
          return response.data;
        } catch (error) {
          if (error.response && error.response.status === 401) {
            return error.response.data;
          } else {
            console.log(error);
          }
        }
      }

     async emilimarroles(id) {
        try {
            const response = await axios.delete(`/deleteroles/${id}`);
            return response.data;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    async selectroles() {
        try {
            const response = await axios.get("/getroles"); // Reemplaza con la URL de tu API
            if (response.status === 200) {
                console.log("datos roles", response.data);
                return response.data;
                
            } else {
                console.error("Error al cargar datos desde la API");
                return [];
            }
        } catch (error) {
            console.error("Error al cargar opciones desde la API:", error);
            return [];
        }
    }

    //USER ROLES
    async userrolesget() {
        try {
            const response = await axios.get("/getuserroles");
            if (response && response.data) {
                return { status: true, records: response.data };
            } else {
                console.error("Respuesta inválida o sin registros.");
                return { status: false, records: [] };
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return { status: false, message: error.response.data.message };
            } else {
                console.log(error);
                return { status: false, message: "Error interno del servidor" };
            }
        }
    }
    async selectuserindex() {
        try {
            const response = await axios.get("/useradminindexx"); 
            if (response.status === 200) {
                console.log("datos usuario", response.data);
                return response.data;
                
            } else {
                console.error("Error al cargar datos desde la API");
                return [];
            }
        } catch (error) {
            console.error("Error al cargar opciones desde la API:", error);
            return [];
        }
    }
    async registraruserroles(userroles) {
        try {
            const response = await axios.post("/postuserroles", userroles);
            console.log("Respuesta de Servicio user roles",response);
            return response.data;
        } catch (error) {
            console.log(error);
            return { status: false, message: "Error interno del servidor" };
        }
    }
    async modificaruserroles(userroles) {
        try {
          const response = await axios.put(
            `/putuserroles/${userroles.id}`,
            userroles
          );
          return response.data;
        } catch (error) {
          if (error.response && error.response.status === 401) {
            return error.response.data;
          } else {
            console.log(error);
          }
        }
      }
      async eliminaruserroles(id) {
        try {
            const response = await axios.delete(`/deleteuserroles/${id}`);
            console.log("Es el dato a eliminar", response.data);
            return response.data;

        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }

}
export default Roles;